module.exports = __webpack_public_path__ + "static/media/secondary-2-literary.23cabe49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-2-literary.jpg
// module id = 169
// module chunks = 0